// extracted by mini-css-extract-plugin
module.exports = {"layoutMember":"Index_layoutMember_Pb4ZV"};